const ArrowDownIcon = ({ size = 16, color = '#000' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    stroke={color}
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    className="lucide lucide-chevron-down-icon lucide-chevron-down"
    viewBox="0 0 24 24"
  >
    <path d="m6 9 6 6 6-6"></path>
  </svg>
);

export default ArrowDownIcon;
